import PropTypes from 'prop-types';
import { camelCase } from 'lodash';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle
import {
  LineItemContainer,
  LineItem,
  LineItemValue,
} from 'components/Comparison/LineItems';
import {
  formatFeatureFactory,
  determineBestFeatureCapabilityFactory,
} from 'components/Comparison/LineItems/helpers';

const INTERIOR_FEATURES = [
  'leather',
  'moonroof',
  'heated_seats',
  'keyless_entry',
  'climate_control',
];

const TECHNOLOGY_FEATURES = [
  'apple_carplay',
  'android_auto',
  'satellite_radio',
  'bluetooth',
  'navigation_system',
];

export default function Interior({ comparison }) {
  const { t } = useTranslation();
  return (
    <LineItemContainer
      title={t(`comparison.lineItems.features.interior`)}
      comparison={comparison}
    >
      <LineItem title={t(`comparison.lineItems.features.interiorFeatures`)}>
        {INTERIOR_FEATURES.map((feature) => (
          <LineItemValue
            key={feature}
            comparison={comparison}
            getValue={formatFeatureFactory(feature)}
            getSubText={() =>
              t(`comparison.lineItems.features.${camelCase(feature)}`)
            }
            determineWinner={determineBestFeatureCapabilityFactory(feature)}
          />
        ))}
      </LineItem>
      <LineItem title={t('comparison.lineItems.features.technology')}>
        {TECHNOLOGY_FEATURES.map((feature) => (
          <LineItemValue
            key={feature}
            comparison={comparison}
            getValue={formatFeatureFactory(feature)}
            getSubText={() =>
              t(`comparison.lineItems.features.${camelCase(feature)}`)
            }
            determineWinner={determineBestFeatureCapabilityFactory(feature)}
          />
        ))}
      </LineItem>
    </LineItemContainer>
  );
}

Interior.propTypes = {
  comparison: PropTypes.object,
};
